import React, { useState, useEffect } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import "select2/dist/css/select2.min.css";
import "select2";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-fixedheader/js/dataTables.fixedHeader.min.js";
import "datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.min.css";
import "datatables.net-fixedcolumns";
import "weather-icons/css/weather-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios, { all } from "axios";
import $ from "jquery";
import { Helmet } from "react-helmet-async";
// 👇 Must attach BEFORE requiring the plugin
window.jQuery = window.$ = $;
// 👇 Use require(), NOT import, so it attaches to global jQuery
require("jquery-slimscroll");

function Header({ compact_mode }) {
  const url = window.location.pathname.trim().slice(1).split("/")[0];
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(false);
  const [modules, setModules] = useState([]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const base_url = process.env.REACT_APP_BASE_URL;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [accessList, setaccessList] = useState([]);
  const [helmet, setHelmet] = useState("");
  const [showRightSidebar, setShowRightSidebar] = useState(false);
  const [search, setSearch] = useState(sessionStorage.getItem("headerSearch") || "");
  const clearSearch = () => {setSearch("");};
  const [toggelCompactMode, setToggelCompactMode] = useState(false);
  const toggleSidebar = () => {setIsSidebarVisible((prev) => !prev);};
  const handleSubmenuClick = (index) => {setActiveSubmenu((prev) => (prev === index ? "" : index));};

  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(user?.default_currency_id || null);
  const [currencyLoading, setCurrencyLoading] = useState(false);

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/get_currencies`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCurrencies(response.data?.options || []);
      localStorage.setItem("currency_rates", JSON.stringify(response.data?.options));
    } catch (error) {
      console.error("Error fetching currencies:", error);
      setCurrencies([]);
    }
  };
  useEffect(() => {
    if (token) {
      fetchCurrencies();
    }
  }, []);

  const handleCurrencyChange = async (currency) => {
    try {
      setCurrencyLoading(true);

      await axios.put(
        `${API_BASE_URL}/employeeinfos/update_currency`,
        {
          currency_id: currency.value,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update selected currency in UI
      setSelectedCurrency(currency.value);
      window.location.reload();
      // Update logged-in user in localStorage
      const updatedUser = {
        ...user,
        default_currency_id: currency.value,
      };

      localStorage.setItem("user", JSON.stringify(updatedUser));

      // Close dropdown
      setShowCurrencyDropdown(false);
    } catch (error) {
      console.error("Error updating currency:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };
  useEffect(() => {
    compact_mode(toggelCompactMode);
  }, [toggelCompactMode]);

  $(".submenu ul li a").on("click", function () {
    // Remove 'active' only from the nested submenu anchors
    $(".submenu ul li a").removeClass("active");

    // Add 'active' to the clicked anchor
    $(this).addClass("active");
  });

  $("#sidebar").on("click", "a", function () {
    let div = $("#sidebar");
    let div2 = $(".sidebar-overlay");
    if ($(this).attr("href") != "#") {
      if (div.hasClass("showsidebar")) {
        div.removeClass("showsidebar");
      }
      if (div2.hasClass("opened")) {
        div2.removeClass("opened");
      }
    }
  });

  $("#mobile_btn").on("click", function () {
    let div = $("#sidebar");
    let div2 = $(".sidebar-overlay");
    div.addClass("showsidebar");
    div2.addClass("opened");
  });

  const handleLogout = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/logout`, {
        id: user.id,
      });
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAccess = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/settings/get_user_access/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        },
      );
      if (response.data.searchUser.length > 0) {
        setaccessList(response.data.searchUser?.[0].module_access);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchAccess();
    }
  }, []);

  useEffect(() => {
    if (accessList?.length <= 0) return;
    async function fetchModulesData() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/settings/get_modules_list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = res.data.modules || [];
        const allowedIds = accessList?.split(",").map((id) => id.trim());

        const filteredData = data.filter((m) =>
          allowedIds.includes(String(m.id)),
        );
        const allLinks = filteredData.map((m) => m.link);

        const checkUrlAccess = allLinks.some((link) => link.includes(url));
        if (!checkUrlAccess) {
          navigate("/shift");
        }
        const sidebarData = filteredData.filter(
          (m) => String(m.widget) !== "1",
        );

        const moduleMap = {};
        sidebarData.forEach((m) => (moduleMap[m.id] = { ...m, children: [] }));
        const tree = [];
        sidebarData.forEach((m) => {
          if (m.parent === "0") tree.push(moduleMap[m.id]);
          else if (moduleMap[m.parent])
            moduleMap[m.parent].children.push(moduleMap[m.id]);
        });
        setModules(tree);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchModulesData();
  }, [accessList]);

  useEffect(() => {
    $(".slimscroll").slimScroll({
      height: "300px",
      color: "#e8e9ea",
      size: "4px",
    });
  }, []);

  const linkStyle = {
    textDecoration: "none",
    padding: "10px 12px",
    borderRadius: "8px",
    background: "#f5f5f5",
    color: "#333",
    fontSize: "14px",
  };
  useEffect(() => {
    const value = sessionStorage.getItem("headerSearch") || "";
    setSearch(value);
  }, [location.pathname]);
  return (
    <>
      <div className="header">
        <div className="main-header">
          <div className="header-left">
            <Link to="/dashboard" className="logo">
              <img
                src={`${base_url}assets/img/logo.svg`}
                alt="Logo"
                style={{ marginTop: "-5px" }}
              />
            </Link>
            <Link to="/dashboard" className="dark-logo">
              <img src={`${base_url}assets/img/logo-white.svg`} alt="Logo" />
            </Link>
          </div>

          <a id="mobile_btn" className="mobile_btn" href="#sidebar">
            <span className="bar-icon" onClick={toggleSidebar}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </a>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div className="d-flex align-items-center" id="header-search">
                <a
                  id="toggle_btn"
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="btn btn-menubar me-1"
                >
                  <i className="ti ti-arrow-bar-to-left"></i>
                </a>
              </div>
              <div
                className="input-group input-group-flat me-auto"
                style={{ width: "400px" }}
              >
                <span className="input-icon-addon">
                  <i className="ti ti-search"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by candidate name, role name, LI URL, etc"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && search.trim()) {
                      navigate(
                        `/business_intelligence/universalsearch?q=${encodeURIComponent(search)}`,
                      );
                    }
                  }}
                />
              </div>
              <div className="d-flex align-items-center">
                <img
                  style={{ width: "100px", marginRight: "10px" }}
                  src="https://positivemoves.com/wp-content/uploads/2025/05/PositiveMoves-Logo.webp"
                />
                <div className="me-1">
                  <a
                    href="#"
                    title={
                      toggelCompactMode
                        ? "Switch to Normal Mode"
                        : "Switch to Compact Mode"
                    }
                    onClick={() => {
                      if (toggelCompactMode == false) {
                        setToggelCompactMode(true);
                      } else {
                        setToggelCompactMode(false);
                      }
                    }}
                    className="btn btn-menubar btnFullscreen"
                  >
                    <i className="ti ti-maximize"></i>
                  </a>
                </div>
                <div className="me-1 position-relative" style={{ position: "relative" }}>
                  <button type="button" className="btn btn-menubar position-relative me-1" title="Select Currency" onClick={() => setShowCurrencyDropdown((prev) => !prev)}>
                    <i className="fa-solid fa-coins"></i>
                  </button>

                  {showCurrencyDropdown && (
                    <div
                      className="currency-dropdown shadow"
                      style={{
                        position: "absolute",
                        top: "45px",
                        right: 0,
                        width: "140px",
                        background: "#fff",
                        borderRadius: "8px",
                        border: "1px solid #eee",
                        zIndex: 9999,
                      }}
                    >
                      <div
                        style={{ padding: "10px 15px", borderBottom: "1px solid #eee", fontWeight: 600, }}>
                        Select Currency
                      </div>

                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        {currencies.length > 0 ? (
                          currencies.map((currency) => (
                            <button
                              key={currency.value}
                              type="button"
                              onClick={() => handleCurrencyChange(currency)}
                              style={{
                                width: "100%",
                                border: "none",
                                background:
                                  selectedCurrency === currency.value
                                    ? "#f0f7ff"
                                    : "#fff",
                                padding: "10px 15px",
                                textAlign: "left",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#f5f5f5";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background =
                                  selectedCurrency === currency.value
                                    ? "#f0f7ff"
                                    : "#fff";
                              }}
                            >
                              <span>
                                {currency.label}
                              </span>

                              {selectedCurrency === currency.value && (
                                <i className="fa-solid fa-check text-success"></i>
                              )}
                            </button>
                          ))
                        ) : (
                          <div
                            style={{
                              padding: "15px",
                              textAlign: "center",
                              color: "#999",
                            }}
                          >
                            No currencies found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {(user.admin == 1 || user.designation_id <= 3) && (
                  <div className="me-1 notification_item">
                    <a
                      className="btn btn-menubar position-relative me-1"
                      onClick={() => {
                        navigate("/notifications");
                      }}
                    >
                      <i className="fa-solid fa-thumbs-up"></i>
                      <span className="notification-status-dot"></span>
                    </a>
                  </div>
                )}
                <div className="me-1">
                  <a className="btn btn-menubar position-relative me-1" title="Logout" onClick={handleLogout}>
                    <i className="ti ti-login me-2"></i>
                  </a>
                </div>  
                {/* <div className="dropdown profile-dropdown">
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <span className="avatar avatar-sm online">
                      <img
                        src={`${base_url}files/media/${user.userpic}`}
                        className="img-fluid rounded-circle"
                        alt="User Profile"
                      />
                    </span>
                  </a>
                  <div className="dropdown-menu shadow-none">
                    <div className="card mb-0">
                      <div className="card-header">
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-lg me-2 avatar-rounded">
                            <img
                              src={`${base_url}files/media/${user.userpic}`}
                              alt="img"
                            />
                          </span>
                          <div>
                            <h5 className="mb-0">
                              {user.firstname + " " + user.lastname}
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <a
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          href="profile.html"
                        >
                          <i className="ti ti-user-circle me-1"></i>My Profile
                        </a>
                        <a
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          href="bussiness-settings.html"
                        >
                          <i className="ti ti-settings me-1"></i>Settings
                        </a>

                        <a
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          href="profile-settings.html"
                        >
                          <i className="ti ti-circle-arrow-up me-1"></i>My
                          Account
                        </a>
                        <a
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          href="knowledgebase.html"
                        >
                          <i className="ti ti-question-mark me-1"></i>Knowledge
                          Base
                        </a>
                      </div>
                      <div className="card-footer">
                        <a
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          onClick={handleLogout}
                        >
                          <i className="ti ti-login me-2"></i>Logout
                        </a>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-end">
              <a className="dropdown-item" href="profile.html">
                My Profile
              </a>
              <a className="dropdown-item" href="profile-settings.html">
                Settings
              </a>
              <a className="dropdown-item" onClick={handleLogout}>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className={isSidebarVisible ? "showsidebar sidebar" : "sidebar"}
        id="sidebar"
      >
        <div
          className="sidebar-logo"
          style={{ background: "white", zIndex: 1000 }}
        >
          <Link
            to="/dashboard"
            style={{ textAlign: "center" }}
            className="logo logo-normal"
          >
            <img
              src={`${base_url}assets/img/logo.svg`}
              alt="Logo"
              style={{ marginTop: "-10px" }}
            />
          </Link>
          <Link to="/dashboard" className="logo-small">
            <img src={`${base_url}assets/img/logo-small.svg`} alt="Logo" />
          </Link>
          <Link to="/dashboard" className="dark-logo">
            <img src={`${base_url}assets/img/logo-white.svg`} alt="Logo" />
          </Link>
        </div>
        <div className="modern-profile p-3 pb-0">
          <div className="text-center rounded bg-light p-3 mb-4 user-profile">
            <div className="avatar avatar-lg online mb-3">
              <img
                src={`${base_url}files/media/${user.userpic}`}
                className="img-fluid rounded-circle"
                alt="User Profile"
              />
            </div>
            <h6 className="fs-12 fw-normal mb-1">
              {user.firstname + " " + user.lastname}
            </h6>
            {/* <p className="fs-10">System Admin</p> */}
          </div>
        </div>
        <div className="sidebar-header p-3 pb-0 pt-2">
          <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
            <div className="avatar avatar-md onlin">
              <img
                src={`${base_url}assets/img/profiles/avatar-02.jpg`}
                alt="Img"
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="text-start sidebar-profile-info ms-2">
              <h6 className="fs-12 fw-normal mb-1">
                {user.firstname + " " + user.lastname}
              </h6>
              {/* <p className="fs-10">System Admin</p> */}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between menu-item mb-3">
            <div className="me-3">
              <a href="calendar.html" className="btn btn-menubar">
                <i className="ti ti-layout-grid-remove"></i>
              </a>
            </div>
            <div className="me-3">
              <a href="chat.html" className="btn btn-menubar position-relative">
                <i className="ti ti-brand-hipchat"></i>
                <span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">
                  5
                </span>
              </a>
            </div>
            <div className="me-3 notification-item">
              <a
                href="activity.html"
                className="btn btn-menubar position-relative me-1"
              >
                <i className="ti ti-bell"></i>
                <span className="notification-status-dot"></span>
              </a>
            </div>
            <div className="me-0">
              <a href="email.html" className="btn btn-menubar">
                <i className="ti ti-message"></i>
              </a>
            </div>
          </div>
        </div>
        <Helmet>
          <title>PINE 2.0 | {helmet}</title>
        </Helmet>
        <div
          className="sidebar-inner slimscroll"
          style={{ overflow: "scroll" }}
        >
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li>
                <ul>
                  {modules.map((mod, index) => (
                    <React.Fragment key={mod.id}>
                      {mod.children.length === 0 ? (
                        // ---- MAIN MODULE WITHOUT CHILDREN ----
                        <li
                          className={`${activeSubmenu === index ? "active" : ""}`}
                        >
                          <Link
                            to={mod.link}
                            onClick={() => {
                              handleSubmenuClick(index);
                              setHelmet(mod.name);
                            }}
                            className="d-flex align-items-center"
                            // className="d-flex align-items-center gap-2"
                          >
                            {mod.icon && <i className={mod.icon}></i>}
                            <span>{mod.name}</span>
                          </Link>
                        </li>
                      ) : (
                        // ---- MAIN MODULE WITH CHILDREN ----
                        <li className="submenu">
                          <a
                            href="#"
                            onClick={() => {
                              handleSubmenuClick(index);
                              setHelmet(mod.name);
                            }}
                            className={`${activeSubmenu === index ? "active subdrop" : ""}`}
                          >
                            {mod.icon && <i className={mod.icon}></i>}
                            <span>{mod.name}</span>
                            <span className="menu-arrow"></span>
                          </a>
                          <ul>
                            {mod.children.map((child) => (
                              <li key={child.id}>
                                <Link
                                  to={child.link}
                                  className="d-flex align-items-center gap-2"
                                  onClick={() => {
                                    handleSubmenuClick(index);
                                    setHelmet(mod.name);
                                  }}
                                >
                                  {child.icon && <i className={child.icon}></i>}
                                  {child.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* {showRightSidebar && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "300px",
            height: "100vh",
            background: "#fff",
            boxShadow: "-5px 0 20px rgba(0,0,0,0.2)",
            zIndex: 9998,
            padding: "20px",
            overflowY: "auto",
          }}
        >
         
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <h4 style={{ margin: 0 }}>Quick Links</h4>
            <button
              onClick={() => setShowRightSidebar(false)}
              style={{
                border: "none",
                background: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>

         
         <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <Link
            to="/business_intelligence/universalsearch"
            style={linkStyle}
            onMouseEnter={e => e.target.style.background = "#c1bde7ff"}
            onMouseLeave={e => e.target.style.background = "#f5f5f5"}
          >
            Universal Search
          </Link>
         
        </div>
        </div>
      )} */}
    </>
  );
}

export default Header;
